import React, { Component } from "react";
import { connect } from "react-redux";
import { actions as toCollegeToolActions } from "../../../../../redux/modules/tocollagetool";
import { get } from "../../../../../utils/request";
import "./style.css";
class HotMajor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      css: {},
      markArray: [1, 0],
      hotMajors: [],
    };
  }
  componentDidMount() {
    this.fixCss();
    this.requestHotJuniorMajor();
    this.requestHotRegularMajor();
  }
  render() {
    const { handleAddHotMajor } = this.props;
    return (
      <div
        style={{ height: this.state.css.minHeight }}
        className="hotMajor_box"
      >
        <div
          onClick={() => this.activateTab(0)}
          className={
            this.state.markArray[0]
              ? "hotMajor_choose_regular"
              : "hotMajor_no_choose_regular"
          }
        >
          <div>本科相关专业</div>
          <div
            className={
              this.state.markArray[0]
                ? "hotMajor_choose_line"
                : "hotMajor_no_choose_line"
            }
          ></div>
        </div>
        <div
          onClick={() => this.activateTab(1)}
          className={
            this.state.markArray[1]
              ? "hotMajor_choose_junior"
              : "hotMajor_no_choose_junior"
          }
        >
          <div>专科相关专业</div>
          <div
            className={
              this.state.markArray[1]
                ? "hotMajor_choose_line"
                : "hotMajor_no_choose_line"
            }
          ></div>
        </div>
        <div className="clear"></div>
        <div className="hot_major_item_box">
          {this.state.hotMajors.map((item, index) => {
            return (
              <div
                onClick={() => handleAddHotMajor(item)}
                key={index}
                className="hot_major_item"
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  /**
   * 请求用户专业条件
   */
  requestHotJuniorMajor = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/hot/majors/junior").then((res) => {
      let hotMajors = JSON.parse(JSON.stringify(res.data.majors));
      dispatch(toCollegeToolActions.setHotJuniorMajor(hotMajors));
    });
  };

  requestHotRegularMajor = () => {
    const { dispatch } = this.props;
    get("/public/v1/toCollage/hot/majors/regular").then((res) => {
      let hotMajors = JSON.parse(JSON.stringify(res.data.majors));
      dispatch(toCollegeToolActions.setHotRegularMajor(hotMajors));
      this.setState({
        hotMajors: this.props.hotRegularMajor,
      });
    });
  };
  activateTab = (id) => {
    let tmpMarkArray = [0, 0];
    tmpMarkArray[id] = 1;
    if (tmpMarkArray[0] === 1) {
      this.setState({
        hotMajors: this.props.hotRegularMajor,
      });
    } else {
      this.setState({
        hotMajors: this.props.hotJuniorMajor,
      });
    }
    this.setState({ markArray: tmpMarkArray });
  };

  fixCss = () => {
    let minHeight = window.innerHeight;
    this.setState({
      css: {
        minHeight: minHeight / 2,
      },
    });
  };
}
const mapStateToProps = (state) => {
  return {
    majorCondition: state.toCollageTool.toCollageData.majorCondition,
    hotJuniorMajor: state.toCollageTool.toCollageData.hotJuniorMajor,
    hotRegularMajor: state.toCollageTool.toCollageData.hotRegularMajor,
  };
};
export default connect(mapStateToProps)(HotMajor);



// WEBPACK FOOTER //
// ./src/containers/ToCollegeTool/ToCollegeToolMajor/components/HotMajor/index.js